var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "form-group",
      class: { "has-error": _vm.errors.has("invoiceId") }
    },
    [
      _c(
        "label",
        { staticClass: "col-sm-2 control-label", attrs: { for: "invoiceId" } },
        [_vm._v("Invoices to follow up on:")]
      ),
      _vm._v(" "),
      !_vm.disabled
        ? _c("div", { staticClass: "col-sm-5" }, [
            _c("div", { staticClass: "select-dropdown" }, [
              _c(
                "select",
                {
                  directives: [
                    {
                      name: "validate",
                      rawName: "v-validate.disable",
                      value: "required",
                      expression: "'required'",
                      modifiers: { disable: true }
                    },
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.selectedInvoiceIds,
                      expression: "selectedInvoiceIds"
                    }
                  ],
                  staticClass: "form-control",
                  class: {
                    "invalid-state": _vm.selectedInvoiceIds.includes(
                      _vm.noInvoicesMessage
                    )
                  },
                  attrs: {
                    "data-vv-as": "invoices",
                    id: "invoiceId",
                    name: "invoiceId",
                    multiple: "",
                    disabled: _vm.timeEntry.isAuditEdit
                  },
                  on: {
                    change: [
                      function($event) {
                        var $$selectedVal = Array.prototype.filter
                          .call($event.target.options, function(o) {
                            return o.selected
                          })
                          .map(function(o) {
                            var val = "_value" in o ? o._value : o.value
                            return val
                          })
                        _vm.selectedInvoiceIds = $event.target.multiple
                          ? $$selectedVal
                          : $$selectedVal[0]
                      },
                      _vm.changeInvoice
                    ]
                  }
                },
                [
                  this.timeEntry.sendEmail === "Yes" &&
                  _vm.timeEntry.attachInvoice === "Yes"
                    ? [
                        _vm._l(_vm.unpaidInvoices, function(invoice) {
                          return [
                            _c(
                              "option",
                              {
                                attrs: { disabled: invoice.Error },
                                domProps: { value: invoice.invoiceId },
                                on: {
                                  mousedown: function($event) {
                                    return _vm.handleOptionClick(
                                      invoice.invoiceId
                                    )
                                  }
                                }
                              },
                              [
                                _vm._v(
                                  "\n                            " +
                                    _vm._s(invoice.invoiceId) +
                                    " - " +
                                    _vm._s(
                                      invoice.isSubscription
                                        ? invoice.companyName + " - "
                                        : ""
                                    ) +
                                    _vm._s(invoice.overdueDays) +
                                    " days\n                        "
                                )
                              ]
                            )
                          ]
                        })
                      ]
                    : _vm._l(_vm.unpaidInvoices, function(invoice) {
                        return _c(
                          "option",
                          {
                            domProps: { value: invoice.invoiceId },
                            on: {
                              mousedown: function($event) {
                                return _vm.handleOptionClick(invoice.invoiceId)
                              }
                            }
                          },
                          [
                            _vm._v(
                              "\n                        " +
                                _vm._s(invoice.invoiceId) +
                                " - " +
                                _vm._s(
                                  invoice.isSubscription
                                    ? invoice.companyName + " - "
                                    : ""
                                ) +
                                _vm._s(invoice.overdueDays) +
                                " days\n                    "
                            )
                          ]
                        )
                      })
                ],
                2
              )
            ]),
            _vm._v(" "),
            _vm.errors.has("invoiceId")
              ? _c("p", { staticClass: "text-danger" }, [
                  _vm._v(_vm._s(_vm.errors.first("invoiceId")))
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.selectedInvoiceIds && _vm.selectedInvoiceIds.length > 0
              ? _c("div", { staticClass: "selected-invoices" }, [
                  _c("small", { staticClass: "text-muted" }, [
                    _vm._v(
                      "Selected invoices: " +
                        _vm._s(_vm.selectedInvoiceIds.join(", "))
                    )
                  ]),
                  _vm._v(" "),
                  _vm.subscriberList && _vm.subscriberList.length > 1
                    ? _c("div", [
                        this.timeEntry.sendEmail === "Yes"
                          ? _c("div", [
                              _c("small", { staticClass: "text-danger" }, [
                                _vm._v(
                                  "You selected invoices from multiple subscribers. Email will be sent to the last selected subscriber"
                                )
                              ])
                            ])
                          : _c("div", [
                              _c("small", { staticClass: "text-warning" }, [
                                _vm._v(
                                  "You have selected invoices from multiple subscribers"
                                )
                              ])
                            ])
                      ])
                    : _vm._e()
                ])
              : _vm._e()
          ])
        : _c("div", { staticClass: "col-sm-6" }, [
            _c("p", [_vm._v(_vm._s(_vm.timeEntry.invoiceId))])
          ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-9bfe4164", { render: render, staticRenderFns: staticRenderFns })
  }
}